export const CHECK_NAME_LABELS: Record<string, string> = {
  INN_FOUND: "Наличие компании в реестре РКН",
  COMPANY_NAME_RESOLVED: "Сравнение наименования с данными реестра ркн",
  PRIVACY_POLICY_FOUND: "Наличие на сайте политики обработки персональных данных",
  IS_DOMAIN_RUSSIAN: "Юрисдикция размещения сайта",
  COOKIES_FOUND: "Наличие cookies",
  COOKIES_AGREEMENT_FOUND: "Наличие согласия на хранение cookies",
  PRIVATE_DATA_FORMS_FOUND: "Наличие формы сбора персональных данных",
  GOOGLE_ANALYTICS_REQUESTS_FOUND: "Присутствие google аналитики",
};

const CANONICAL_CHECK_KEYS = Object.keys(CHECK_NAME_LABELS);

export const resolveCheckNameKey = (raw: string): string | undefined => {
  const t = raw.trim();
  if (!t) return undefined;
  if (CHECK_NAME_LABELS[t]) return t;
  const upper = t.toUpperCase();
  const hit = CANONICAL_CHECK_KEYS.find((k) => k === upper || k.toUpperCase() === upper);
  return hit;
};

export const labelForCheckName = (checkName: string): string | undefined => {
  const key = resolveCheckNameKey(checkName);
  return key ? CHECK_NAME_LABELS[key] : undefined;
};

export const getCheckDisplayDescription = (item: {
  checkName: string;
  checkNameDescription?: string | null;
}): string => {
  const key = resolveCheckNameKey(item.checkName);
  if (key === "INN_FOUND") {
    return CHECK_NAME_LABELS.INN_FOUND;
  }
  const raw = item.checkNameDescription;
  if (raw != null && String(raw).trim() !== "") {
    return String(raw);
  }
  return (key ? CHECK_NAME_LABELS[key] : undefined) ?? item.checkName;
};
